import { useTrackingManager } from "@provider/tracking";
import { useEffect } from "react";

export function Tracker() {
  const tracker = useTrackingManager();

  useEffect(() => {
    tracker.trackEvent("userarea-delinger.builder.visitedCourse");
  }, []);

  return null;
}
